export default "__VITE_ASSET__DhpT4zUs__"